import { loadingController } from "@ionic/vue";
import { useI18n } from "vue-i18n";

export async function showLoader() {
	const { t } = useI18n();
	const loader = await loadingController.create({
		message: t("common.loading-dot"),
	});
	await loader.present();

	async function dismiss() {
		await loader.dismiss();
	}

	return dismiss;
}
